import { OrderModel } from "../../../shared/models/order/order-item.model";
import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { OrdersResponseModel } from "../../../shared/models/api/orders-response.model";
import { useAppDispatch, useAppSelector } from "../../../../redux/store";
import { changePagination, getOrders } from "../../../../redux/slices/orders-slice";
import { OrderCard } from "./order-card/order-card";
import BarekamPagination from "../pagination/barekam-pagination";
import { AllOrdersResponseModel } from "../../../shared/models/api/all-orders-response.model";
import { OrdersTableColumn } from "../models/column-models";
import NoOrders from "../no-orders";
import { ToolPanel } from "../tool-panel/tool-panel";
import { OrderCardsContainer } from "./styled";
import { useNavigate } from "react-router-dom";
import PayConfirmDialog from "../order-list/pay-confirm-dialog";

const OrderCards = (props: OrderCardProps) => {
    const [selectedOrders, setSelectedOrders] = useState(new Map<number, OrderModel>());
    const { isLoading, orderStateId } = useAppSelector(state => state.ordersReducer);
    const [dialogOpen, setDialogState] = useState<boolean>(false);
    const [orderToPay, setOrderToPay] = useState<OrderModel>();
    const { ordersData, columns, isWarehouseWorker, setPaymentPopupOpened } = props;

    const dispatch = useAppDispatch();

    useEffect(() => {
        setSelectedOrders(prevState => {
            prevState.clear();
            return prevState;
        });
    }, [orderStateId])

    function handleSelect(order: OrderModel): void {
        if (order.orderId && selectedOrders.has(order.orderId)) {
            setSelectedOrders(selectedOrders => {
                order.orderId && selectedOrders.delete(order.orderId);
                return new Map(selectedOrders);
            });
        } else {
            setSelectedOrders(selectedOrders => {
                order.orderId && selectedOrders.set(order.orderId, order);
                return new Map(selectedOrders);
            });
        }
    }

    function handlePageChange(event: any, newPage: number): void {
        dispatch(changePagination({ pageSize: ordersData.pageSize, currentPage: newPage - 1 }));
        dispatch(getOrders({ page: newPage - 1 }));
    }

    return (
        <OrderCardsContainer>
            <ToolPanel selectedOrders={selectedOrders} isWarehouseWorker={isWarehouseWorker} orderStateId={orderStateId} />
            {dialogOpen && orderToPay && (
                <PayConfirmDialog open={dialogOpen} setOpen={setDialogState} setPaymentPopupOpened={setPaymentPopupOpened} order={orderToPay} />
            )}
            {ordersData?.orders?.length
                ? <Grid container
                    gridTemplateColumns={'repeat(auto-fill, minmax(22rem, 1fr))'}
                    display={'grid'}
                    padding={'1rem'}
                    columnGap={'1rem'}
                    rowGap={'1rem'}>
                    {ordersData?.orders?.map(order =>
                        <OrderCard clicked={() => props.openAction(order)}
                            order={order}
                            columns={columns}
                            isSelected={!!order.orderId && selectedOrders.has(order.orderId)}
                            onSelect={handleSelect} payButtonClicked={() => { setDialogState(true), setOrderToPay(order) }}
                            key={order.orderId} />
                    )}
                </Grid>
                : isLoading ? <></> : <NoOrders />
            }
            <BarekamPagination {...ordersData} onPageChange={handlePageChange} />
        </OrderCardsContainer>
    )
}

interface OrderCardProps {
    columns: OrdersTableColumn[],
    ordersData: OrdersResponseModel,
    allOrdersData?: AllOrdersResponseModel,
    isWarehouseWorker?: boolean,
    openAction: (order: OrderModel) => void,
    setPaymentPopupOpened?: (isSucceeded: boolean) => void;
}

export default OrderCards;
